// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pageSlider {
    display: flex;
    position: absolute;
    font-size: xxx-large;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    align-items: center;
    font-weight: bolder;
    z-index: 10;
    pointer-events: none;
}

.pageSlider > div {
    display: inline-block;
    padding: 1%;
    margin: 0 5vh;
    color: #f3f4ff;
    background-color: rgb(36, 10, 202);
    border-radius: 100px 0;
    animation: buttonRotate 4s infinite ease-in-out;
    cursor: pointer;
    pointer-events: auto;
}

@keyframes buttonRotate {
    0% {
        background-color: rgb(36, 10, 202);
        box-shadow: 0 0 10px rgba(0, 100, 255, 0.8);
        transform: scale(1);
    }

    25% {
        background-color: rgb(26, 50, 220);
        box-shadow: 0 0 30px rgba(0, 100, 255, 0.5), 0 0 60px rgba(0, 100, 255, 0.2);
        transform: scale(1.05);
    }

    50% {
        background-color: rgb(16, 40, 180);
        box-shadow: 0 0 50px rgba(0, 100, 255, 0.5), 0 0 100px rgba(0, 100, 255, 0.3);
        transform: scale(1.1);
    }

    75% {
        background-color: rgb(36, 10, 202);
        box-shadow: 0 0 30px rgba(0, 100, 255, 0.5), 0 0 60px rgba(0, 100, 255, 0.2);
        transform: scale(1.05);
    }

    100% {
        background-color: rgb(36, 10, 202);
        box-shadow: 0 0 10px rgba(0, 100, 255, 0.8);
        transform: scale(1);
    }
}

.pageSlider > div:hover {
    display: inline-block;
    padding: 1%;
    margin: 0 5vh;
    color: #f3f4ff;
    background-color: rgb(36, 10, 202);
    border-radius: 100px 0;
    animation: buttonRotateShaking 4s infinite ease-in-out;
}

@keyframes buttonRotateShaking {
    0% {
        background-color: rgb(36, 10, 202);
        box-shadow: 0 0 10px rgba(0, 100, 255, 0.8);
        transform: scale(1) translateX(0);
    }

    10% {
        transform: scale(1) translateX(-5px);
    }

    20% {
        transform: scale(1) translateX(5px);
    }

    30% {
        transform: scale(1) translateX(-5px);
    }

    40% {
        transform: scale(1) translateX(5px);
    }

    50% {
        background-color: rgb(16, 40, 180);
        box-shadow: 0 0 50px rgba(0, 100, 255, 0.5), 0 0 100px rgba(0, 100, 255, 0.3);
        transform: scale(1.1) translateX(0);
    }

    60% {
        transform: scale(1) translateX(-5px);
    }

    70% {
        transform: scale(1) translateX(5px);
    }

    80% {
        transform: scale(1) translateX(-5px);
    }

    90% {
        transform: scale(1) translateX(5px);
    }

    100% {
        background-color: rgb(36, 10, 202);
        box-shadow: 0 0 10px rgba(0, 100, 255, 0.8);
        transform: scale(1) translateX(0);
    }
}

.pageSlider > div:active {
    animation: buttonRotateShaking 4s infinite ease-in-out;
}

.waterDrop {
    padding: 1px !important;
    width: 0.5vh;
    height: 0.5vh;
    background-color: rgba(0, 69, 173, 0.8) !important;
    border-radius: 100% !important;
    pointer-events: none;
}

@keyframes rainDrop {
    0% {
        transform: translate(0, 0) scale(1);
        opacity: 1;
    }
    50% {
        opacity: 0.7;
    }
    100% {
        transform: translate(0, 50px) scale(0.5);
        opacity: 0;
    }
}

.sliderContentWrapper {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow-x: hidden;
}
/*   
  .sliderContent {
    display: flex;
    width: 100%;
    height: 100%;
    transition: transform 0.5s ease-in-out;
  } */
  
  .sliderPage {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
  }

  /* Entrando da direita (next) */
  .animate-in-left {
    animation: slideInLeft 0.5s forwards;
  }
  .animate-out-left {
    animation: slideOutLeft 0.5s forwards;
  }
  
  /* Entrando da esquerda (prev) */
  .animate-in-right {
    animation: slideInRight 0.5s forwards;
  }
  .animate-out-right {
    animation: slideOutRight 0.5s forwards;
  }
  
  @keyframes slideInLeft {
    from {
      transform: translateX(100%);
      opacity: 0.5;
    }
    to {
      transform: translateX(0%);
      opacity: 1;
    }
  }
  
  @keyframes slideOutLeft {
    from {
      transform: translateX(0%);
      opacity: 1;
    }
    to {
      transform: translateX(-100%);
      opacity: 0.5;
    }
  }
  
  @keyframes slideInRight {
    from {
      transform: translateX(100%);
      opacity: 0.5;
    }
    to {
      transform: translateX(0%);
      opacity: 1;
    }
  }
  
  @keyframes slideOutRight {
    from {
      transform: translateX(0%);
      opacity: 1;
    }
    to {
      transform: translateX(100%);
      opacity: 0.5;
    }
  }
  
  `, "",{"version":3,"sources":["webpack://./src/components/PageSliders/pageSlider.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kBAAkB;IAClB,oBAAoB;IACpB,8BAA8B;IAC9B,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,aAAa;IACb,cAAc;IACd,kCAAkC;IAClC,sBAAsB;IACtB,+CAA+C;IAC/C,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI;QACI,kCAAkC;QAClC,2CAA2C;QAC3C,mBAAmB;IACvB;;IAEA;QACI,kCAAkC;QAClC,4EAA4E;QAC5E,sBAAsB;IAC1B;;IAEA;QACI,kCAAkC;QAClC,6EAA6E;QAC7E,qBAAqB;IACzB;;IAEA;QACI,kCAAkC;QAClC,4EAA4E;QAC5E,sBAAsB;IAC1B;;IAEA;QACI,kCAAkC;QAClC,2CAA2C;QAC3C,mBAAmB;IACvB;AACJ;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,aAAa;IACb,cAAc;IACd,kCAAkC;IAClC,sBAAsB;IACtB,sDAAsD;AAC1D;;AAEA;IACI;QACI,kCAAkC;QAClC,2CAA2C;QAC3C,iCAAiC;IACrC;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,mCAAmC;IACvC;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,mCAAmC;IACvC;;IAEA;QACI,kCAAkC;QAClC,6EAA6E;QAC7E,mCAAmC;IACvC;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,mCAAmC;IACvC;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,mCAAmC;IACvC;;IAEA;QACI,kCAAkC;QAClC,2CAA2C;QAC3C,iCAAiC;IACrC;AACJ;;AAEA;IACI,sDAAsD;AAC1D;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,kDAAkD;IAClD,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI;QACI,mCAAmC;QACnC,UAAU;IACd;IACA;QACI,YAAY;IAChB;IACA;QACI,wCAAwC;QACxC,UAAU;IACd;AACJ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;AACA;;;;;;KAMK;;EAEH;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA,+BAA+B;EAC/B;IACE,oCAAoC;EACtC;EACA;IACE,qCAAqC;EACvC;;EAEA,gCAAgC;EAChC;IACE,qCAAqC;EACvC;EACA;IACE,sCAAsC;EACxC;;EAEA;IACE;MACE,2BAA2B;MAC3B,YAAY;IACd;IACA;MACE,yBAAyB;MACzB,UAAU;IACZ;EACF;;EAEA;IACE;MACE,yBAAyB;MACzB,UAAU;IACZ;IACA;MACE,4BAA4B;MAC5B,YAAY;IACd;EACF;;EAEA;IACE;MACE,2BAA2B;MAC3B,YAAY;IACd;IACA;MACE,yBAAyB;MACzB,UAAU;IACZ;EACF;;EAEA;IACE;MACE,yBAAyB;MACzB,UAAU;IACZ;IACA;MACE,2BAA2B;MAC3B,YAAY;IACd;EACF","sourcesContent":[".pageSlider {\n    display: flex;\n    position: absolute;\n    font-size: xxx-large;\n    justify-content: space-between;\n    width: 100%;\n    height: 100%;\n    align-items: center;\n    font-weight: bolder;\n    z-index: 10;\n    pointer-events: none;\n}\n\n.pageSlider > div {\n    display: inline-block;\n    padding: 1%;\n    margin: 0 5vh;\n    color: #f3f4ff;\n    background-color: rgb(36, 10, 202);\n    border-radius: 100px 0;\n    animation: buttonRotate 4s infinite ease-in-out;\n    cursor: pointer;\n    pointer-events: auto;\n}\n\n@keyframes buttonRotate {\n    0% {\n        background-color: rgb(36, 10, 202);\n        box-shadow: 0 0 10px rgba(0, 100, 255, 0.8);\n        transform: scale(1);\n    }\n\n    25% {\n        background-color: rgb(26, 50, 220);\n        box-shadow: 0 0 30px rgba(0, 100, 255, 0.5), 0 0 60px rgba(0, 100, 255, 0.2);\n        transform: scale(1.05);\n    }\n\n    50% {\n        background-color: rgb(16, 40, 180);\n        box-shadow: 0 0 50px rgba(0, 100, 255, 0.5), 0 0 100px rgba(0, 100, 255, 0.3);\n        transform: scale(1.1);\n    }\n\n    75% {\n        background-color: rgb(36, 10, 202);\n        box-shadow: 0 0 30px rgba(0, 100, 255, 0.5), 0 0 60px rgba(0, 100, 255, 0.2);\n        transform: scale(1.05);\n    }\n\n    100% {\n        background-color: rgb(36, 10, 202);\n        box-shadow: 0 0 10px rgba(0, 100, 255, 0.8);\n        transform: scale(1);\n    }\n}\n\n.pageSlider > div:hover {\n    display: inline-block;\n    padding: 1%;\n    margin: 0 5vh;\n    color: #f3f4ff;\n    background-color: rgb(36, 10, 202);\n    border-radius: 100px 0;\n    animation: buttonRotateShaking 4s infinite ease-in-out;\n}\n\n@keyframes buttonRotateShaking {\n    0% {\n        background-color: rgb(36, 10, 202);\n        box-shadow: 0 0 10px rgba(0, 100, 255, 0.8);\n        transform: scale(1) translateX(0);\n    }\n\n    10% {\n        transform: scale(1) translateX(-5px);\n    }\n\n    20% {\n        transform: scale(1) translateX(5px);\n    }\n\n    30% {\n        transform: scale(1) translateX(-5px);\n    }\n\n    40% {\n        transform: scale(1) translateX(5px);\n    }\n\n    50% {\n        background-color: rgb(16, 40, 180);\n        box-shadow: 0 0 50px rgba(0, 100, 255, 0.5), 0 0 100px rgba(0, 100, 255, 0.3);\n        transform: scale(1.1) translateX(0);\n    }\n\n    60% {\n        transform: scale(1) translateX(-5px);\n    }\n\n    70% {\n        transform: scale(1) translateX(5px);\n    }\n\n    80% {\n        transform: scale(1) translateX(-5px);\n    }\n\n    90% {\n        transform: scale(1) translateX(5px);\n    }\n\n    100% {\n        background-color: rgb(36, 10, 202);\n        box-shadow: 0 0 10px rgba(0, 100, 255, 0.8);\n        transform: scale(1) translateX(0);\n    }\n}\n\n.pageSlider > div:active {\n    animation: buttonRotateShaking 4s infinite ease-in-out;\n}\n\n.waterDrop {\n    padding: 1px !important;\n    width: 0.5vh;\n    height: 0.5vh;\n    background-color: rgba(0, 69, 173, 0.8) !important;\n    border-radius: 100% !important;\n    pointer-events: none;\n}\n\n@keyframes rainDrop {\n    0% {\n        transform: translate(0, 0) scale(1);\n        opacity: 1;\n    }\n    50% {\n        opacity: 0.7;\n    }\n    100% {\n        transform: translate(0, 50px) scale(0.5);\n        opacity: 0;\n    }\n}\n\n.sliderContentWrapper {\n  position: relative;\n  width: 100vw;\n  height: 100vh;\n  overflow-x: hidden;\n}\n/*   \n  .sliderContent {\n    display: flex;\n    width: 100%;\n    height: 100%;\n    transition: transform 0.5s ease-in-out;\n  } */\n  \n  .sliderPage {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n  }\n\n  /* Entrando da direita (next) */\n  .animate-in-left {\n    animation: slideInLeft 0.5s forwards;\n  }\n  .animate-out-left {\n    animation: slideOutLeft 0.5s forwards;\n  }\n  \n  /* Entrando da esquerda (prev) */\n  .animate-in-right {\n    animation: slideInRight 0.5s forwards;\n  }\n  .animate-out-right {\n    animation: slideOutRight 0.5s forwards;\n  }\n  \n  @keyframes slideInLeft {\n    from {\n      transform: translateX(100%);\n      opacity: 0.5;\n    }\n    to {\n      transform: translateX(0%);\n      opacity: 1;\n    }\n  }\n  \n  @keyframes slideOutLeft {\n    from {\n      transform: translateX(0%);\n      opacity: 1;\n    }\n    to {\n      transform: translateX(-100%);\n      opacity: 0.5;\n    }\n  }\n  \n  @keyframes slideInRight {\n    from {\n      transform: translateX(100%);\n      opacity: 0.5;\n    }\n    to {\n      transform: translateX(0%);\n      opacity: 1;\n    }\n  }\n  \n  @keyframes slideOutRight {\n    from {\n      transform: translateX(0%);\n      opacity: 1;\n    }\n    to {\n      transform: translateX(100%);\n      opacity: 0.5;\n    }\n  }\n  \n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
